<template>
    <div>
        <el-dialog title="课程列表" width="1200px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
                    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <!-- <el-form-item label="课程标题：">
                <el-input size="small" v-model="formInline.title" placeholder="请输入课程标题"></el-input>
            </el-form-item> -->
            <el-form-item>
                <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column prop="cid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="title" label="课程标题" width="80">
            </el-table-column>
            <el-table-column prop="nums" label="题目数量" width="80">
            </el-table-column>
            <el-table-column prop="cate_type" label="课程类型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.cate_type == 0">题目</div>
                    <div v-else-if="row.cate_type == 1">图文</div>
                    <div v-else>视频</div>
                </template>
            </el-table-column>
            <el-table-column prop="contents" label="课程内容" width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fulfillment_type" label="履约类型" width="80" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div v-if="row.fulfillment_type == 1">视频</div>
                    <div v-else-if="row.fulfillment_type == 2">音频</div>
                    <div v-else-if="row.fulfillment_type == 3">图片</div>
                    <div v-else-if="row.fulfillment_type == 4">文字</div>
                    <div v-else>富文本</div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="status" label="课程状态" width="100" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-switch
                    @change="swchange"
                    v-model="row.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                    </el-switch>
                </template>
            </el-table-column> -->
            <el-table-column prop="sort" label="排序" width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="添加时间" width="auto">
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="80">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
                </template>
            </el-table-column>
        </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            <AddDetails :cid='cid' :show.sync="addDialogStatus" @refesh_list="getdata"></AddDetails>
           <Updatadetails :info="updateInfo" :show.sync="updateDialogStatus" size="small" @refesh_list="getdata"></Updatadetails>

        </el-dialog>
    </div>
</template>
<script>
import { getCourseList,getCourseDel,getCourSet} from '../../api/userMG';
import Pagination from '../../components/Pagination';
import AddDetails from './addDetails.vue';
import Updatadetails from './updatedetails.vue';
export default {
    name: 'Add',
    components: {
        Pagination,AddDetails,Updatadetails
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        cid: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            addDialogStatus:false,
            updateDialogStatus:false,
            formInline: {
                cid:'',
                page: 1
            },
            updateInfo:{},
            loading: false, //是显示加载
            listData:[],
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
        }
    },
    watch: {
        show(val) {
            if (val) {
                this.formInline.cid = this.cid
                this.getdata()
            }
        }
    },
    methods: {
        swchange(e){
            console.log(e);

        },
        add(){
           this.addDialogStatus = true
        },
        open() {
            
        },
        update(row) {
            getCourSet({ clid: row.clid, echo: 'get' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.updateDialogStatus = true
                    this.updateInfo = res.info
                }
            })
        },
        del(row) {
            this.$confirm('确定要删除吗?', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getCourseDel({ clid: row.clid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        // 搜索事件
        search() {
            this.getdata()
        },
        getdata() {
            this.loading = true
            getCourseList(this.formInline).then(res => {
                this.listData = res.info.data
                this.pageparm.total =res.info.total
                this.loading = false
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        closeForm(){
            this.$emit('update:show', false)
            this.loading = false
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        }
    }
}
</script>
<style scoped >
.dialog-footer {
    margin: 40px 0px 0px 280px;
}
</style>



// WEBPACK FOOTER //
// src/views/course/coursedetail.vue